module.exports = __webpack_public_path__ + "static/card-profile1-square-3122abf4a3e1067926c08dee7684522d.jpg";